export const socialLinks = {
  twitter: '#',
  facebook: '#',
  pinterest: '#',
  instagram: '#',
  linkedin: '#',
  youtube: '#',
  tiktok: '#'
};

export const contactInfo = {
  phone1: '+92-302-9356457',
  phone2: '+92-302-9356457',
  whatsapp: '+92-302-9356457',
  email: 'Info@alnoortutors.com',
  footerEmail: 'Info@alnoortutors.com', // Email shown in footer
  location: 'Online Worldwide'
};
